// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"129":"a08d60a4","624":"6cbefe38","661":"9c6e070c","912":"9f0e4128"}[chunkId] + ".chunk.css";
};